import React from "react"
import CallToAction from "./call-to-action"
import VideoSurface from "./util/video-surface"
import focalPointToObjectPosition from "../utils/object-position"

export interface MainHeroProps {
  title: string
  headline: string
  headerImage: Queries.PageFieldsFragment["headerImage"]
  headerVideo?: Queries.PageFieldsFragment["headerVideo"]["video"]
  titleImage: string
  preamble: string
  ctas: Queries.PageFieldsFragment["ctas"]
  variant?: string
}

const MainHero = (props: MainHeroProps) => {
  return (
    <section
      className={`c-main-hero ${props.variant ? `${props.variant}` : ""} `}
      style={{
        backgroundImage: `url(${
          props.headerImage ? props.headerImage.url_xl : null
        })`,
        backgroundPosition:
          props.headerImage && props.headerImage.focalPoint
            ? focalPointToObjectPosition(props.headerImage.focalPoint)
            : "center",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
    >
      {props.headerVideo && (
        <VideoSurface
          className="c-main-hero__video"
          video={props.headerVideo}
        />
      )}
      <div className="c-main-hero__text-container o-wrapper">
        <div>
          <div
            className={`c-main-hero__header-text ${
              props.titleImage ? "-has-asset" : ""
            }`}
            style={{
              backgroundImage: `url(${props.titleImage})`,
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
            }}
          >
            {props.headline && (
              <div
                className="c-main-hero__headline -pre-line c-heading--n"
                dangerouslySetInnerHTML={{ __html: props.headline }}
              />
            )}
            <h1 className="u-visually-hidden">{props.title}</h1>
          </div>
          <div className="o-5-of-12@large u-left@large">
            <div
              className="c-main-hero__preamble"
              dangerouslySetInnerHTML={{ __html: props.preamble }}
            />
            <div className="u-flex">
              {props.ctas &&
                props.ctas.map(cta => (
                  <CallToAction
                    key={cta.id}
                    color={cta.hasColor ? "green" : "transparent"}
                    isTransparent={cta.isTransparent}
                    openInNewTab={cta.openInNewTab}
                    url={cta.url}
                  >
                    {cta.text}
                  </CallToAction>
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default MainHero
